<template>
  <tg-layout prefixCls="reward-record--project" :headerHeight="headerHeight">
    <template slot="header">
      <slot name="toolbar" :on-search="handleSearch"></slot>
      <tg-amount-bar v-if="showAmount" :columns="amountColumns" :row="amount"></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="tableColumns"
      :proxy="proxy"
      align="center"
      header-row-class-name="tg-table--has-actionis"
      row-class-name="tg-table--has-actionis"
      :fit="true"
      size="medium"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template v-for="(_, slotName) in $scopedSlots" :slot="slotName" slot-scope="scope">
        <slot :name="slotName" v-bind="{ ...scope }"></slot>
      </template>
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name :row="scope.row" :column="scope.column"></tg-user-full-name>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgAmountBar from "@/components/amount/TgAmountBar";

import TgUserFullName from "@/components/slot/TgUserFullName";
import apis from "@/apis";

const api = apis.tg_business.reward.record;

export default {
  components: {
    TgLayout,
    TgAmountBar,
    TgUserFullName,
  },
  data() {
    return {
      amount: {},
      tableColumns: [],
      amountColumns: [],
    };
  },
  props: {
    showAmount: Boolean,
    // 請求資訊
    request: Object,
    project: {
      type: String,
      required: true,
      validator(value) {
        return ["detail", "users"].indexOf(value) > -1;
      },
    },
    params: Object,
  },
  computed: {
    columnsRequest() {
      return {
        project: this.project,
        type: this.reward.type,
        status: this.reward.status,
      };
    },
    reward() {
      return this.params.reward;
    },
    game_time() {
      return this.params.game_time;
    },
    event() {
      return this.params.event;
    },
    searchData() {
      return {
        type: this.reward.type,
        status: this.reward.status,
        game_time: this.game_time,
        event: this.event,
        ...this.request,
        upper_agent: this.params.upper_agent,
      };
    },
    proxy() {
      let proxy = this.project === "detail" ? api.getDetail : api.getUsers;
      return (params) => proxy({ ...this.searchData, ...params });
    },
    headerHeight() {
      return this.showAmount ? 140 : 80;
    },
  },
  created() {
    this.$store.commit("breadcrumb/clear");

    if (!this.reward || !this.reward.type) {
      this.$router.push({ name: "tg_business.reward-record" });
      return;
    }

    api.getColumns(this.columnsRequest).then((response) => {
      if (this.project === "detail") {
        this.tableColumns = response.data.tableColumns;
        this.amountColumns = response.data.amountColumns;
      } else {
        this.tableColumns = response.data;
      }
      this.$refs.table.init(this.searchData);
    });
  },
  methods: {
    handleLoaded(response) {
      if(response.retcode == 0){
        this.amount = response.total;
      }
    },
    handleSearch(request) {
      this.$refs.table.search({
        ...this.searchData,
        ...request,
      });
    },
  },
  watch: {
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
